import { Trans } from 'react-i18next';
import MainBlockLayout from '../../components/MainBlockLayout';
import './AnnualReports.css';

import annual_report_2024_2025 from '../../files/annual_report_2024_2025.pdf';

// To publish a new report: add the PDF to src/files, import it above and add a line here.
// Newest first; each entry is shown as one card.
const ANNUAL_REPORTS = [
  { year: '2024-2025', file: annual_report_2024_2025 },
];

function MainBlock() {
  return (
    <div className="reportGrid">
      {ANNUAL_REPORTS.map((report) => (
        <div key={report.year} className="reportCard">
          <div className="reportIcon" aria-hidden="true">📄</div>
          <h5 className="reportTitle"><Trans i18nKey="annual_report_label" /></h5>
          <p className="reportYear">{report.year}</p>
          <div className="reportButtons">
            <a className="reportBtn reportBtnPrimary" href={report.file} target="_blank" rel="noreferrer">
              <Trans i18nKey="Preview" />
            </a>
            <a className="reportBtn reportBtnOutline" href={report.file} download>
              <Trans i18nKey="Download" />
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MainBlockLayout(MainBlock);
